export default {
    topics: [
        {
            title: ' Cancel ',
            href: 'sm-centralCatalog-Cancel.html',
            attributes: { 'data-id': 'sm-centralCatalog-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-centralCatalog-Cancel-d66e2247',
            topics: [],
        },
        {
            title: ' CheckValidationAccess ',
            href: 'sm-centralCatalog-CheckValidationAccess.html',
            attributes: { 'data-id': 'sm-centralCatalog-CheckValidationAccess' },
            menu: { hasChildren: false },
            tocID: 'sm-centralCatalog-CheckValidationAccess-d66e2255',
            topics: [],
        },
        {
            title: ' StartValidation ',
            href: 'sm-centralCatalog-StartValidation.html',
            attributes: { 'data-id': 'sm-centralCatalog-StartValidation' },
            menu: { hasChildren: false },
            tocID: 'sm-centralCatalog-StartValidation-d66e2263',
            topics: [],
        },
        {
            title: ' Validation ',
            href: 'sm-centralCatalog-Validation.html',
            attributes: { 'data-id': 'sm-centralCatalog-Validation' },
            menu: { hasChildren: false },
            tocID: 'sm-centralCatalog-Validation-d66e2271',
            topics: [],
        },
    ],
};

